
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.281 2.281L26 4.562l-.625-.656-.688-.719-9.625 9.626-1.624-1.657-.72-.719-.718.72-1.469 1.5-.719.687.72.719a1.094 1.094 0 010 1.562l-.72.688-5.437 5.437c-1.363 1.363-1.57 3.469-.625 5.063L2.281 28.28l1.439 1.44 1.469-1.469c1.593.945 3.699.738 5.062-.625l6.125-6.156a1.094 1.094 0 011.563 0l.718.718.688-.718 1.5-1.469.718-.719-.718-.718-1.657-1.625 9.625-9.625-.718-.688L27.437 6l2.282-2.281zm-3.593 3.75l1.28 1.282-8.187 8.187-1.281-1.281zm-11.97 7.25l6 6-.374.375c-1.14-.504-2.45-.52-3.375.407l-6.125 6.125a2.125 2.125 0 01-3.031 0 2.125 2.125 0 010-3.032l6.125-6.125c.925-.926.91-2.234.406-3.375z"}})])
          )
        }
      }
    